import { render, staticRenderFns } from "./ApplicationStatistics.vue?vue&type=template&id=7d552f64&"
import script from "./ApplicationStatistics.vue?vue&type=script&lang=js&"
export * from "./ApplicationStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports